// Generated by: node scripts/export-install-variants.mjs
// Paste INSTALL_VARIANTS into src/quote/constants.js only

export const INSTALL_VARIANTS = [
  { price:    4086, vId: '39861578170465' },
  { price:    4140, vId: '39861578203233' },
  { price:    4485, vId: '39861578236001' },
  { price:    4830, vId: '39861578268769' },
  { price:    5175, vId: '39861578301537' },
  { price:    5520, vId: '39861578334305' },
  { price:    5865, vId: '39861578367073' },
  { price:    6210, vId: '39861578399841' },
  { price:    6555, vId: '39861578432609' },
  { price:    6900, vId: '39861578465377' },
  { price:    7240, vId: '39861578498145' },
  { price:    7590, vId: '39861578530913' },
  { price:    7935, vId: '39861578563681' },
  { price:    8280, vId: '39861578596449' },
  { price:    8625, vId: '39861578629217' },
  { price:    8970, vId: '39861578661985' },
  { price:    9315, vId: '39861578694753' },
  { price:    9660, vId: '39861578727521' },
  { price:   10005, vId: '39861578760289' },
  { price:   10350, vId: '39861578793057' },
  { price:   10695, vId: '39861578825825' },
  { price:   11040, vId: '39861578858593' },
  { price:   11385, vId: '39861578891361' },
  { price:   11730, vId: '39861578924129' },
  { price:   12075, vId: '39861578956897' },
  { price:   12420, vId: '39861578989665' },
  { price:   12765, vId: '39861579022433' },
  { price:   13110, vId: '39861579055201' },
  { price:   13234, vId: '39861579087969' },
  { price:   13800, vId: '39861579120737' },
  { price:   14145, vId: '39861579153505' },
  { price:   14490, vId: '39861579186273' },
  { price:   14835, vId: '39861579219041' },
  { price:   15180, vId: '39861579251809' },
  { price:   15870, vId: '39861579284577' },
  { price:   16560, vId: '39861579317345' },
  { price:   17250, vId: '39861579350113' },
  { price:   17940, vId: '39861579382881' },
  { price:   18630, vId: '39861579415649' },
  { price:   19320, vId: '39861579448417' },
  { price:   20010, vId: '39861579481185' },
  { price:   20700, vId: '39861579513953' },
  { price:   21390, vId: '39861579546721' },
  { price:   22080, vId: '39861579579489' },
  { price:   22770, vId: '39861579612257' },
  { price:   23460, vId: '39861579645025' },
  { price:   24150, vId: '39861579677793' },
  { price:   24840, vId: '39861579710561' },
  { price:   25530, vId: '39861579743329' },
  { price:   26220, vId: '39861579776097' },
  { price:   26910, vId: '39861579808865' },
  { price:   27600, vId: '39861579841633' },
  { price:   28290, vId: '39861579874401' },
  { price:   28980, vId: '39861579907169' },
  { price:   29670, vId: '39861579939937' },
  { price:   30360, vId: '39861579972705' },
  { price:   31050, vId: '39861580005473' },
  { price:   31740, vId: '39861580038241' },
  { price:   32430, vId: '39861580071009' },
  { price:   33120, vId: '39861580103777' },
  { price:   33810, vId: '39861580136545' },
  { price:   34500, vId: '39861580169313' },
  { price:   35190, vId: '39861580202081' },
  { price:   35880, vId: '39861580234849' },
  { price:   36570, vId: '39861580267617' },
  { price:   37260, vId: '39861580300385' },
  { price:   37950, vId: '39861580333153' },
  { price:   38640, vId: '39861580365921' },
  { price:   39330, vId: '39861580398689' },
  { price:   40020, vId: '39861580431457' },
  { price:   40710, vId: '39861580464225' },
  { price:   41400, vId: '39861580496993' },
  { price:   42780, vId: '39861580529761' },
  { price:   44160, vId: '39861580562529' },
  { price:   45540, vId: '39861580595297' },
  { price:   46920, vId: '39861580628065' },
  { price:   48300, vId: '39861580660833' },
  { price:   49680, vId: '39861580693601' },
  { price:   51060, vId: '39861580726369' },
  { price:   52440, vId: '39861580759137' },
  { price:   53820, vId: '39861580791905' },
  { price:   55200, vId: '39861580824673' },
  { price:   56580, vId: '39861580857441' },
  { price:   57960, vId: '39861580890209' },
  { price:   59340, vId: '39861580922977' },
  { price:   60720, vId: '39861580955745' },
  { price:   62100, vId: '39861580988513' },
  { price:   65550, vId: '39861581021281' },
  { price:   69000, vId: '39861581054049' },
  { price:   72450, vId: '39861581086817' },
  { price:   75900, vId: '39861581119585' },
  { price:   82800, vId: '39861581185121' },
  { price:   89700, vId: '39861581217889' },
  { price:   96600, vId: '39861581250657' },
  { price:  103500, vId: '39861581283425' },
  { price:  110400, vId: '39861581316193' },
  { price:  124200, vId: '39861581348961' },
  { price:  138000, vId: '39861581381729' },
  { price:  172500, vId: '39861581414497' },
  { price:  195000, vId: '41645826408545' },
  { price:  225000, vId: '42235807268961' },
  { price:  275000, vId: '42235807531105' },
  { price:  325000, vId: '42235808514145' },
  { price: 0.99, vId: '42235809497185' },
];
